import React from 'react';
import {Button, Text} from 'wix-style-react';

import {useTranslate} from '@wix/premium-bricks-translate';

import availableDomainIconPath from '../../assets/AvailableDomainIcon.svg';
import domainInfoIconPath from '../../assets/DomainInfoIcon.svg';
import serverErrorIconPath from '../../assets/ServerErrorIcon.svg';

import s from './InfoPlaceholder.scss';

interface InfoPlaceholderProps {
  dataHook: string;
  isLoaded: boolean;
  isError: boolean;
  isAvailable: boolean;
  domainName: string | null;
  whoisInfo: string | null;
  isAuthorized: boolean;
}

export const InfoPlaceholder = (props: InfoPlaceholderProps) => {
  const {t} = useTranslate();

  const {dataHook, isError, isLoaded, isAvailable, whoisInfo, domainName, isAuthorized} = props;

  const toUrlParams = (sourceObject: {[key: string]: unknown}) => {
    return Object.keys(sourceObject)
      .map((key) => `${key}=${sourceObject[key]}`)
      .join('&');
  };

  const getSearchDomainUrl = () => {
    let searchDomainUrl = '';

    if (isAvailable && domainName) {
      searchDomainUrl = `https://premium.wix.com/wix/api/mpContainerStaticController?originWidgetName=domains#/domains?${toUrlParams(
        {
          referralAdditionalInfo: 'WHOISDomainSearch',
          domainSearch: true,
          domainName,
        },
      )}`;

      if (!isAuthorized) {
        const redirectUrl = encodeURIComponent(searchDomainUrl);
        searchDomainUrl = `https://users.wix.com/signin?postLogin=${redirectUrl}&postSignUp=${redirectUrl}&sendEmail=true&view=login`;
      }
    }

    return searchDomainUrl;
  };

  return (
    <div className={`${s.root} ${isLoaded ? s.loaded : ''}`} data-hook={dataHook}>
      {!isLoaded && (
        <>
          <img src={domainInfoIconPath} alt="" width="161" height="82" />
          <div>
            <Text weight="normal" size="small">
              {t('whois.result_info.placeholder')}
            </Text>
          </div>
        </>
      )}

      {isLoaded && !isError && !whoisInfo && !isAvailable && (
        <>
          <img src={domainInfoIconPath} alt="" width="161" height="82" />
          <div>
            <Text weight="normal" size="small">
              {t('whois.result_info.warning_empty')}
            </Text>
          </div>
        </>
      )}

      {isLoaded && !isError && isAvailable && (
        <>
          <img src={availableDomainIconPath} alt="" width="161" height="82" />
          <Text tagName="p">
            {t({
              id: 'whois.result_info.available_domain.title',
              values: {domainName},
              components: [<strong key={0} />, <strong key={1} />],
            })}
          </Text>

          <div>
            <Button as="a" href={getSearchDomainUrl()} priority="primary" size="medium" skin="standard">
              {t('whois.result_info.available_domain.button')}
            </Button>
          </div>
        </>
      )}

      {isLoaded && isError && (
        <>
          <img src={serverErrorIconPath} alt="" width="118" height="112" />
          <div>
            <Text weight="normal" size="small">
              {t('whois.result_info.server_error')}
            </Text>
          </div>
        </>
      )}
    </div>
  );
};
